import { Icon } from "../components/Icon";
import { PhoneFrame } from "../components/PhoneFrame";
import { SCREENS } from "../data/screens";
import { RichText, useSiteTranslation } from "../i18n";
import "../styles/dark-mode.css";

/** Shows the app's dark theme with the dark chat and filter screens. */
export function DarkModeSection() {
  const { t } = useSiteTranslation();
  const points = t("home.darkMode.points", { returnObjects: true });

  return (
    <section className="dark-mode" id="dark-mode">
      <div className="wrap dark-mode-grid">
        <div className="dark-mode-copy" data-reveal>
          <p className="eyebrow">{t("home.darkMode.eyebrow")}</p>
          <h2>
            <RichText k="home.darkMode.title" />
          </h2>
          <p className="dark-mode-text">{t("home.darkMode.text")}</p>
          <ul>
            {points.map((point, index) => (
              <li key={index}>
                <Icon name="check" />
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="dark-mode-visual" data-reveal style={{ "--delay": ".1s" }}>
          <div className="dark-mode-glow" aria-hidden="true" />
          <PhoneFrame className="dark-mode-phone dark-mode-phone--left" src={SCREENS.chatsDark.src} alt={t(SCREENS.chatsDark.alt)} />
          <PhoneFrame className="dark-mode-phone dark-mode-phone--right" src={SCREENS.filtersDark.src} alt={t(SCREENS.filtersDark.alt)} />
        </div>
      </div>
    </section>
  );
}
